<template>
  <div>
    <v-card class="pt-4 pb-5">
      <b-row>
        <b-col cols="2">
          <label class="pt-4 float-right defaultLabel"> Typ: </label>
        </b-col>
        <b-col cols="8">
          <label class="pt-4 defaultLabel">
            {{ typeDisplay }}
          </label>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label class="pt-4 float-right defaultLabel"> Bezeichnungen: </label>
        </b-col>
        <b-col cols="8">
          <v-text-field
            v-model="valueDe"
            label="Deutsch"
            @input="updateContent"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="2" />
        <b-col cols="8">
          <v-text-field
            v-model="valueFr"
            label="Französisch"
            @input="updateContent"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2" />
        <b-col cols="8">
          <v-text-field
            v-model="valueIt"
            label="Italienisch"
            @input="updateContent"
          />
        </b-col>
      </b-row>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    wageSupplementDayOfHourConf: {
      type: Object,
      required: true,
    },
    wageSupplementTypes: {
      type: Object,
      required: true,
    },
    contentsField: {
      type: String,
      default: "",
    },
    textField: {
      type: String,
      default: "text",
    },
    typeField: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedWageSupplementType: 0,
      valueDe: "",
      valueFr: "",
      valueIt: "",
    };
  },
  computed: {
    typeDisplay() {
      const type =
        this.wageSupplementTypes[
          this.wageSupplementDayOfHourConf[this.typeField]
        ];

      if (type) {
        return type;
      }
      return "";
    },
  },
  watch: {
    wageSupplementDayOfHourConf: function (newVal) {
      this.setTypeConfigurationFields(newVal);
    },
  },
  created() {
    this.setTypeConfigurationFields(this.wageSupplementDayOfHourConf);
  },
  methods: {
    setTypeConfigurationFields(config) {
      this.selectedWageSupplementType = config[this.typeField];
      if (config[this.contentsField]) {
        config[this.contentsField].map((content) => {
          if (content.language === "de-CH") {
            this.valueDe = content.value;
          } else if (content.language === "fr-CH") {
            this.valueFr = content.value;
          } else if (content.language === "it-CH") {
            this.valueIt = content.value;
          }
        });
      }
    },
    updateContent() {
      let content = [
        {
          id: 0,
          value: this.valueDe,
          language: "de-CH",
        },
        {
          id: 0,
          value: this.valueFr,
          language: "fr-CH",
        },
        {
          id: 0,
          value: this.valueIt,
          language: "it-CH",
        },
      ];

      this.$emit("inputContent", content);
    },
  },
};
</script>

<style scoped></style>
